export default __webpack_public_path__ + "static/media/gfg.efe99d96.png";